export default {
    methods: {
        active(lang){

            return lang == this.locale;
        },
    }
}
